const updateCartNum = (qty: number) => {
    const cartNum = $('.cart-count');
    if (!cartNum.length) return;
    const currentQty = parseInt(cartNum.text());
    const newQty = currentQty + qty;

    cartNum.text(newQty);
};

export const addToCart = (sku: string, qty) => {
    const url = `/DefaultCart/AddToCart?Code=${sku}&Customization=null&Quantity=${qty}&TrackingData=null`;
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                updateCartNum(qty);
                return response.json();
            } else {
                updateCartNum(qty);
                return { error: 'Expected JSON but received: ' + contentType };
            }
        })
        .catch((error) => {
            console.error(
                'There was a problem with the fetch operation:',
                error
            );
        });
};

export const addToWishlist = (sku: string, qty) => {
    const url: string = `/Wishlist/AddToCart?Code=${sku}&Customization=null&CustomerCartName=Wishlist&IsWishlist=true&Quantity=${qty}&TrackingData=null`;

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json();
            } else {
                return { error: 'Expected JSON but received: ' + contentType };
            }
        })
        .catch((error) => {
            console.error(
                'There was a problem with the fetch operation:',
                error
            );
        });
};

export const removeFromWishlist = (sku: string, qty) => {
    const url: string = `/Wishlist/RemoveItem?Code=${sku}&Customization=null&CustomerCartName=Wishlist&IsWishlist=false&Quantity=${qty}&TrackingData=null`;

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json();
            } else {
                return { error: 'Expected JSON but received: ' + contentType };
            }
        })
        .catch((error) => {
            console.error(
                'There was a problem with the fetch operation:',
                error
            );
        });
};
